module.exports = __webpack_public_path__ + "img/ID_Tagline_black.6ce478ca.png";